/**
 * The sizes supported by this component.
 * @type {Object<String>}
 */
export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium'
};
